var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"text--bold",attrs:{"color":_vm.chipColor,"label":""}},[_vm._v(" "+_vm._s(_vm.$t("measures."+_vm.innerValue))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }